export default __webpack_public_path__ + "static/media/Sayse.b592ea0c.png";